/* eslint-disable @typescript-eslint/no-explicit-any */
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ActionType} from "@/util/type/store.ts";
import {WorkspaceService} from "@/service/WorkspaceService.ts";
import {ReadWorkSpaceResponse, WorkSpace} from "@/model/response/workspace/ReadWorkSpaceResponse.ts";
import {CreateWorkspaceRequest} from "@/model/request/workspace/CreateWorkspaceRequest.ts";
import {CreateWorkspaceResponse} from "@/model/response/workspace/CreateWorkspaceResponse.ts";
import {UpdateWorkSpaceRequest} from "@/model/request/workspace/UpdateWorkSpaceRequest.ts";
import {BaseResponse} from "@/model/response/BaseResponse.ts";
import {DeleteWorkSpaceRequest} from "@/model/request/workspace/DeleteWorkSpaceRequest.tsx";
import {ReadByUserIdRequest} from "@/model/request/workspace/ReadByUserIdRequest.ts";

export type WorkspaceState = {
    loading: boolean;
    workspace: WorkSpace[];
    workspaceById: WorkSpace[];
    selectedWorkspace: WorkSpace;
    CreateWorkSpaceBilling: CreateWorkspaceRequest
};

const initialState: WorkspaceState = {
    loading: false,
    workspace: [],
    workspaceById: [],
    selectedWorkspace: {} as WorkSpace,
    CreateWorkSpaceBilling: {} as CreateWorkspaceRequest,
};

const action = {
    create: createAsyncThunk(
        "workspace/create",
        async (payload: ActionType<CreateWorkspaceRequest>, thunkAPI) => {
            return (await WorkspaceService.create(thunkAPI, payload.data)).data;
        }
    ),
    readWorkSpace: createAsyncThunk(
        "workspace/read",
        async (_, thunkAPI) => {
            return (await WorkspaceService.read(thunkAPI)).data;
        }
    ),
    readWorkSpaceByUserId: createAsyncThunk(
        "workspace/readByUserId",
        async (payload: ReadByUserIdRequest, thunkAPI) => {
            return (await WorkspaceService.readByUserId(thunkAPI, payload)).data;
        }
    ),
    updateWorkSpace: createAsyncThunk("workspace/update", async (payload: ActionType<UpdateWorkSpaceRequest>, thunkAPI) => {
        return (await WorkspaceService.update(thunkAPI, payload.data)).data;
    }),
    deleteWorkSpace: createAsyncThunk("workspace/delete", async (payload: ActionType<DeleteWorkSpaceRequest>, thunkAPI) => {
        return (await WorkspaceService.delete(thunkAPI, payload.data)).data;
    })
};

const slice = createSlice({
    name: "workspace",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        setSelectedWorkspace(state, {payload}) {
            state.selectedWorkspace = payload;
        },
        setCreateWorkSpaceBilling(state, {payload}) {
            state.CreateWorkSpaceBilling = payload;
        },
        reset: () => ({...initialState})

        // setCurrentWorkspaceId(state, {payload}) {
        //   state.currentWorkspaceId = {workspaceId: payload.id, workspaceName: payload.name};
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.create.fulfilled, (state, action) => {
                const response = action.payload as CreateWorkspaceResponse;
                state.loading = false;
                if (response.responseCode === "00")
                    action.meta.arg.onSuccess?.(action.payload);
                else {
                    action.meta.arg.onError?.(action.payload);
                }
            })
            .addCase(action.readWorkSpace.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.readWorkSpace.fulfilled, (state, action) => {
                const response = action.payload as ReadWorkSpaceResponse;
                state.loading = false;
                if (response.responseCode === "00") {
                    state.workspace = response.data
                }
            }).addCase(action.readWorkSpaceByUserId.pending, (state) => {
            state.workspaceById = []
            state.loading = true
        }).addCase(action.readWorkSpaceByUserId.fulfilled, (state, action) => {
            state.loading = false
            console.log("I am a gee")
            const response = action.payload as ReadWorkSpaceResponse;
            if (response.responseCode == "00") {
                state.workspaceById = response.data
            }
        }).addCase(action.updateWorkSpace.pending, (state) => {
            state.loading = true
        }).addCase(action.updateWorkSpace.fulfilled, (state, action) => {
            state.loading = false
            const response = action.payload as BaseResponse
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.deleteWorkSpace.pending, (state) => {
            state.loading = true
        }).addCase(action.deleteWorkSpace.fulfilled, (state, action) => {
            state.loading = false
            const response = action.payload as BaseResponse
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        });
    },
});

export const workspace = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
